<template>
    <section class="actions">
        <slot/>
    </section>
</template>
<script>
export default {
    name: 'SectionActions',
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

section.actions {
    display: flex;
    align-items: center;
    justify-content: center;

    > :first-child:not(:only-child) {
        will-change: margin;
    }

    @include breakpoint-min(xs) {
        flex-direction: column-reverse;

        > :first-child:not(:only-child) {
            margin: 20px 0 0 0;
        }
    }

    @include breakpoint-min(md) {
        flex-direction: row;

        > :first-child:not(:only-child) {
            margin: 0 20px 0 0;
        }
    }
}
</style>
